/**
 * Asset path utilities for generating URLs to static and dynamic assets
 */

/**
 * Generate URL for chemical structure images
 * @param {string} filename - The image filename
 * @returns {string} Full URL to the image
 */
export function getCoaImageUrl(filename) {
  if (!filename) return '';
  
  // If filename is already a full URL, return as-is
  if (filename.startsWith('http')) {
    return filename;
  }
  
  // Check if we're in production and need to use full API URL
  const isProduction = process.env.NODE_ENV === 'production';
  const apiBase = process.env.REACT_APP_API_URL;
  
  if (isProduction && apiBase) {
    // In production, use the API base URL for cross-origin requests
    const baseUrl = apiBase.endsWith('/api') ? apiBase.slice(0, -3) : apiBase;
    return `${baseUrl}/uploads/coa-images/${filename}`;
  }
  
  // For localhost/development, use relative paths
  return `/uploads/coa-images/${filename}`;
}

/**
 * Generate URL for product images
 * @param {string} filename - The image filename
 * @returns {string} Full URL to the image
 */
export function getProductImageUrl(filename) {
  if (!filename) return '';
  
  if (filename.startsWith('http')) {
    return filename;
  }
  
  return `/images/products/${filename}`;
}

/**
 * Generate URL for company logo
 * @param {string} filename - The logo filename (optional)
 * @returns {string} Full URL to the logo
 */
export function getLogoUrl(filename = 'prasilabs-logo.png') {
  if (filename.startsWith('http')) {
    return filename;
  }
  
  return `/${filename}`;
}
